<template>
  <section class="layout-section">
    <article class="layout-section__content">
      <section v-appear:right="{ delay: [$scroll, 800, 50] }" class="layout-section__hgroup -flex -spacing">
        <h2 class="layout-section__heading -bigger">{{ $t('common.navigation.eventsNext') }}</h2>
      </section>

      <section class="layout-grid -bigger">
        <div
          v-for="({ title, conference, date, siteLink, overrideConference, thumbnail, slug }, index) in nextEvents"
          :key="`${date}-${index}`"
          v-appear="{ threshold: 0, offset: 0, delay: getDelay(index) }"
          class="layout-grid__item"
        >
          <a
            v-if="siteLink"
            :href="siteLink"
            target="_blank"
            rel="noopener"
            class="layout-grid__figure -small"
            :style="{ '--image': `url('${eventThumbFallback(slug, thumbnail)}')` }"
          />

          <span
            v-else
            class="layout-grid__figure -small"
            :style="{ '--image': `url('${eventThumbFallback(slug, thumbnail)}')` }"
          />

          <div class="layout-grid__content">
            <h4 class="layout-grid__title">{{ title }}</h4>
            <h6 class="layout-grid__subtitle">{{ overrideConference || conference }}</h6>
            <h6 class="layout-grid__label">{{ date }}</h6>
          </div>
        </div>
      </section>
    </article>

    <article class="layout-section__content">
      <section v-appear:right class="layout-section__hgroup -flex -spacing">
        <h2 class="layout-section__heading -bigger">{{ $t('events.pastEvents.title') }}</h2>
      </section>

      <section class="layout-grid -bigger">
        <div
          v-for="({ title, thumbnail, date, siteLink, overrideConference, conference, slug }, index) in pastEvents"
          :key="`${date}-${index}`"
          v-appear="{ delay: index * 25 }"
          class="layout-grid__item"
        >
          <a
            v-if="siteLink"
            :href="siteLink"
            target="_blank"
            class="layout-grid__figure -small"
            :style="{ '--image': `url('${eventThumbFallback(slug, thumbnail)}')` }"
          />

          <span
            v-else
            class="layout-grid__figure -small"
            :style="{ '--image': `url('${eventThumbFallback(slug, thumbnail)}')` }"
          />

          <div class="layout-grid__content">
            <h4 class="layout-grid__title">{{ title }}</h4>
            <h6 class="layout-grid__subtitle">{{ overrideConference || conference }}</h6>
            <h6 class="layout-grid__label">{{ date }}</h6>
          </div>
        </div>
      </section>
    </article>
  </section>
</template>

<script>
import moment from 'moment'
import _sortBy from 'lodash.sortby'

export default {
  name: 'EventsIndex',
  computed: {
    nextEvents() {
      const allNextEvents = Object.entries(this.$i18n.messages[this.$i18n.locale].conferences).reduce(
        (nextEvents, [slug, conference]) => {
          const nextEvent = conference.events.find(event => moment(event.startDate).isAfter(moment()))
          return nextEvent ? [...nextEvents, { ...nextEvent, conference: conference.name, slug }] : nextEvents
        },
        []
      )

      return _sortBy(allNextEvents, ['startDate'])
    },
    pastEvents() {
      const allPastEvents = Object.entries(this.$i18n.messages[this.$i18n.locale].conferences).reduce(
        (pastEvents, [slug, conference]) => {
          const events = conference.events.filter(event => moment(event.startDate).isBefore(moment()))
          return [...pastEvents, ...events.map(event => ({ ...event, conference: conference.name, slug }))]
        },
        []
      )

      return _sortBy(allPastEvents, ['startDate']).reverse()
    }
  },
  methods: {
    getDelay(index) {
      const delay = (index * 25) % 200
      return index < 3 ? [this.$scroll, 900 + delay, delay] : delay
    }
  }
}
</script>
